// extracted by mini-css-extract-plugin
export default {"root":"SellSteps-root","steps":"SellSteps-steps","step":"SellSteps-step","stepContent":"SellSteps-stepContent","iconCircle":"SellSteps-iconCircle"};